export default __webpack_public_path__ + "static/media/manageVendor.ebf6aeb2.png";